import React from 'react';

export default function ProductCard({ product, addLabel, onAdd, onOpen }) {
  const stop = (e) => e.stopPropagation();

  return (
    <article
      className="kido-product-card"
      onClick={onOpen}
      style={{ cursor: onOpen ? 'pointer' : undefined }}
    >
      <div className="kido-product-image" style={{ backgroundColor: product.color }}>
        {product.image && <img src={product.image} alt={product.name} />}
        <button type="button" className="kido-heart" aria-label={`Save ${product.name}`} onClick={stop}>♡</button>
        {product.tag && <span className="kido-tag">{product.tag}</span>}
      </div>
      <div className="kido-product-info">
        <div>
          <h3>{product.name}</h3>
          {product.subtitle && <p>{product.subtitle}</p>}
        </div>
        <strong>{product.price}</strong>
      </div>
      <button
        type="button"
        className="kido-add-button"
        onClick={(e) => { stop(e); onAdd && onAdd(); }}
      >
        {addLabel} <span>+</span>
      </button>
    </article>
  );
}
